import { BaseDevice, CustomLayout } from '../../base_device'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { DevicePid, EffectIndex, KK, VK } from '@/define/define'
import list_icon from '@/assets/img/device/fe98/list_icon.png'
import { fe98VKCodes } from '../keycode/vkeycode'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_FE98_PRO } from '../../light/light_effect_list'

export class FE98PRO extends BaseDevice {
  name: string = 'FE98_PRO'
  icon: string = list_icon
  width: number = 784

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_FE98_PRO

  square = getDeviceKeySquare(DevicePid.IROKFe98Pro)

  y_number: number = 10
  
  absoluteKey: CustomLayout = {
    0x6e: this.createSquare(714, 2, 36, 75),
    0x70: this.createSquare(714, 2, 36, 75),
    // 0x58: this.createSquare(566, 195),
    0x53: this.createSquare(518, 2),
    0x59: this.createSquare(556, 2),
    0x5f: this.createSquare(593, 2),
  }
  inoperableKeys: KK[] = [0x3b]

  vkcodes = fe98VKCodes
  customLayout: CustomLayout = {
    0xc: this.createSquare(40.5, 2),
    0x24: this.createSquare(21, 2),
    0x3c: this.createSquare(21, 2),
    0x5a: this.createSquare(20, 2),
    0x1: this.createSquare(2, this.y_number),
    0x7: this.createSquare(2, this.y_number),
    0xd: this.createSquare(2, this.y_number),
    0x13: this.createSquare(2, this.y_number),
    0x19: this.createSquare(2, this.y_number),
    0x1f: this.createSquare(2, this.y_number),
    0x25: this.createSquare(2, this.y_number),
    0x2b: this.createSquare(2, this.y_number),
    0x31: this.createSquare(2, this.y_number),
    0x37: this.createSquare(2, this.y_number),
    0x3d: this.createSquare(2, this.y_number),
    0x43: this.createSquare(2, this.y_number),
    0x49: this.createSquare(2, this.y_number),
    0x4f: this.createSquare(2, this.y_number, 75),
    0x5b: this.createSquare(20, this.y_number),
    0x61: this.createSquare(2, this.y_number),
    0x67: this.createSquare(2, this.y_number),
    0x6d: this.createSquare(2, this.y_number),
    0x2: this.createSquare(2, 2, 54.8),
    0x50: this.createSquare(2, 2, 57),
    0x5c: this.createSquare(20, 2),
    0x3: this.createSquare(2, 2, 67.5),
    0x51: this.createSquare(2, 2, 83),
    0x5d: this.createSquare(20, 2),
    0x4: this.createSquare(2, 2, 73),
    0x52: this.createSquare(2, 2, 77),
    0x58: this.createSquare(15, 2),
    0x5e: this.createSquare(8, 2),
    0x5: this.createSquare(2, 2, 47.5),
    0xb: this.createSquare(2, 2, 47.5),
    0x11: this.createSquare(2, 2, 47.5),
    0x23: this.createSquare(2, 2, 212),
    0x3b: this.createSquare(2, 2, 47.5),
    0x41: this.createSquare(2, 2, 47.5),
    0x65: this.createSquare(175, 2),
  }
  brushFirmwareUrl = 'http://s.joyway.net/packages/irok/brush_firmware/FE98_PRO.exe'
}
